import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { bingoBoardApi } from '@/api/powerMarkets/bingoBoardApi.ts';
import { IPlantCard } from '@/interfaces/powerMarkets/bingo/IBingoCard.ts';
import { IBingoPlantData } from '@/interfaces/powerMarkets/bingo/IBingoPlantData.ts';
import { useUserSettingsStore } from '@/stores/userSettingsStore.ts';

export const useBingoStore = defineStore('bingoStore', () => {
    const userSettingsStore = useUserSettingsStore();
    const activeBingoPlantData = ref<Array<IBingoPlantData>>([]);
    const activeBingoBoardPlantIds = computed<Array<string>>(() => {
        const bingoWithOrder = userSettingsStore.userSettings.bingoWithOrder;
        const activeBingoId = userSettingsStore.activeBingoId ?? bingoWithOrder.order.data[0];
        const activeBoard = activeBingoId ? bingoWithOrder.objectsToStore[activeBingoId]?.data : null;
        return activeBoard?.cards
            .filter((card): card is IPlantCard => card.type === 'plant' && !!card.value)
            .map(card => card.value) ?? [];
    });

    function setActiveBingoPlantData (value: Array<IBingoPlantData>): void {
        activeBingoPlantData.value = value;
    }

    async function refreshActiveBingoPlantData (plants: Array<string>): Promise<void> {
        if (!plants.length) {
            setActiveBingoPlantData([]);
            return;
        }

        const response = await bingoBoardApi.postBingo({ plants });
        setActiveBingoPlantData(response.data);
    }

    function updateBingoPlantFromPush (data: IBingoPlantData): void {
        const index = activeBingoPlantData.value.findIndex((p) => p.plantId === data.plantId);
        if (index === -1) return;
        const next = [...activeBingoPlantData.value];
        next[index] = data;
        activeBingoPlantData.value = next;
    }

    return {
        activeBingoPlantData,
        activeBingoBoardPlantIds,
        refreshActiveBingoPlantData,
        setActiveBingoPlantData,
        updateBingoPlantFromPush,
    };
});
